import { ClassList } from "./ClassList";
import { LayoutEntity } from "./Definitions";
import { Dimension as Margin, PlaneDimensions, dimensionClassMap, planeDimensionsClass } from "./Dimension";
import { MediaSpecific, mediaSpecificClassO } from "./Media";
import css from "./Styles/margin.module.scss";

export { Margin };

export type Margins = PlaneDimensions<Margin>;
export type LayoutMargins = LayoutEntity<Margins, "margins">;

const marginClass = (side: string, margin: Margin | undefined, suffix: string): string | undefined =>
    margin !== undefined ? css[`m${side}-${dimensionClassMap[margin]}${suffix}`] : undefined;

export const marginsClass = (margins?: Margins): ClassList =>
    planeDimensionsClass(margins, (side, margin) => marginClass(side, margin, ""));

export const marginsClassMS = (margins?: MediaSpecific<Margins>): ClassList =>
    mediaSpecificClassO(margins, (margins, suffix) => planeDimensionsClass(margins, (side, margin) => marginClass(side, margin, suffix)));

export const marginsClassMSL = (margins: MediaSpecific<LayoutMargins> | undefined): ClassList =>
    mediaSpecificClassO(margins, (layout, suffix) => planeDimensionsClass(layout.margins, (side, margin) => marginClass(side, margin, suffix)));
